var React = require('react');

function SortAsc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.84417 5.30316L5.96029 4.41928L10.3796 0L14.7988 4.41926L13.915 5.30311L11.0039 2.39203L11.0039 9.73086H9.75426L9.75426 2.39309L6.84417 5.30316Z","key":0}),React.createElement("path",{"d":"M5 4.50056H0V3.30056H5V4.50056Z","key":1}),React.createElement("path",{"d":"M0 8.50056H8V7.30056H0V8.50056Z","key":2}),React.createElement("path",{"d":"M0 12.5006H11V11.3006H0V12.5006Z","key":3})]);
}

SortAsc.defaultProps = {"width":"15","height":"13","viewBox":"0 0 15 13","fill":"none"};

module.exports = SortAsc;

SortAsc.default = SortAsc;
